// extracted by mini-css-extract-plugin
export default {"container":"ClientProfile_container__N+MwI","profileContainer":"ClientProfile_profileContainer__qvwHw","accContainer":"ClientProfile_accContainer__UhvGV"};